export default {
  logo: {
    label: 'Logo',
    tooltip: 'The selected logo is displayed in the header of every report.',
  },
  errors: {
    unsupportedFileType: 'The current logo is in an unsupported file format. Please upload a new logo.',
    logoLoadingFailure: 'The current logo could not be loaded. We recommend uploading a new logo.',
  },
};
